// Get Products
export const FETCH_PRODUCTS_BEGIN = "FETCH_PRODUCTS_BEGIN";
export const RECEIVE_PRODUCTS = "RECEIVE_PRODUCTS";
export const FETCH_SINGLE_PRODUCT = "FETCH_SINGLE_PRODUCT";

// FILTERS

export const FORM_REQUEST ='FORM_REQUEST';
export const FORM_SUCCESS = 'FORM_SUCCESS';
export const FORM_FAILURE = 'FORM_FAILURE';
export const FILTER_ALL_SUCCESS = "FILTER_ALL_SUCCESS";
export const FILTER_ALL_REQUEST = "FILTER_ALL_REQUEST";
export const FILTER_ALL_FAILURE = "FILTER_ALL_FAILURE";

export const FILTER_BRAND_SUCCESS = "FILTER_BRAND_SUCCESS";
export const FILTER_BRAND_REQUEST = "FILTER_BRAND_REQUEST";
export const FILTER_BRAND_FAILURE = "FILTER_BRAND_FAILURE";

export const FILTER_COLOUR_SUCCESS = "FILTER_COLOUR_SUCCESS";
export const FILTER_COLOUR_REQUEST = "FILTER_COLOUR_REQUEST";
export const FILTER_COLOUR_FAILURE = "FILTER_COLOUR_FAILURE";

export const FILTER_GENDER_SUCCESS = "FILTER_GENDER_SUCCESS";
export const FILTER_GENDER_REQUEST = "FILTER_GENDER_REQUEST";
export const FILTER_GENDER_FAILURE = "FILTER_GENDER_FAILURE";

export const FILTER_RANGE_SUCCESS = "FILTER_RANGE_SUCCESS";
export const FILTER_RANGE_REQUEST = "FILTER_RANGE_REQUEST";
export const FILTER_RANGE_FAILURE = "FILTER_RANGE_FAILURE";

export const FILTER_RESET_SUCCESS = "FILTER_RESET_SUCCESS";
export const FILTER_SET = "FILTER_SET";

export const FILTER_COLOR = "FILTER_COLOR";
export const FILTER_PRICE = "FILTER_PRICE";
export const SORT_BY = "SORT_BY";

// Search Filters

export const SEARCH_FILTER_ALL_SUCCESS = "SEARCH_FILTER_ALL_SUCCESS";
export const SEARCH_FILTER_ALL_REQUEST = "SEARCH_FILTER_ALL_REQUEST";
export const SEARCH_FILTER_ALL_FAILURE = "SEARCH_FILTER_ALL_FAILURE";

export const COUNTRY_LIST_SUCCESS = "COUNTRY_LIST_SUCCESS";
export const COUNTRY_LIST_REQUEST = "COUNTRY_LIST_REQUEST";
export const COUNTRY_LIST_FAILURE = "COUNTRY_LIST_FAILURE";

export const EDC_DEVICES_SUCCESS = "EDC_DEVICES_SUCCESS";
export const EDC_DEVICES_REQUEST = "EDC_DEVICES_REQUEST";
export const EDC_DEVICES_FAILURE = "EDC_DEVICES_FAILURE";

export const TENDER_TYPE_SUCCESS = "TENDER_TYPE_SUCCESS";
export const TENDER_TYPE_REQUEST = "TENDER_TYPE_REQUEST";
export const TENDER_TYPE_FAILURE = "TENDER_TYPE_FAILURE";

export const EXCHANGE_RATE_SUCCESS = "EXCHANGE_RATE_SUCCESS";
export const EXCHANGE_RATE_REQUEST = "EXCHANGE_RATE_REQUEST";
export const EXCHANGE_RATE_FAILURE = "EXCHANGE_RATE_FAILURE";

export const BANK_SUCCESS = "BANK_SUCCESS";
export const BANK_REQUEST = "BANK_REQUEST";
export const BANK_FAILURE = "BANK_FAILURE";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const LOAD_API_DETAILS_SUCCESS = "LOAD_API_DETAILS_SUCCESS";
export const LOAD_API_DETAILS_REQUEST = "LOAD_API_DETAILS_REQUEST";
export const LOAD_API_DETAILS_FAILURE = "LOAD_API_DETAILS_FAILURE";

export const CARD_TYPE_SUCCESS = "CARD_TYPE_SUCCESS";
export const CARD_TYPE_REQUEST = "CARD_TYPE_REQUEST";
export const CARD_TYPE_FAILURE = "CARD_TYPE_FAILURE";

export const COMMERCIAL_BANK_SUCCESS = "COMMERCIAL_BANK_SUCCESS";
export const COMMERCIAL_BANK_REQUEST = "COMMERCIAL_BANK_REQUEST";
export const COMMERCIAL_BANK_FAILURE = "COMMERCIAL_BANK_FAILURE";

export const SAVE_TENDER_DETAIL_SUCCESS = "SAVE_TENDER_DETAIL_SUCCESS";
export const SAVE_TENDER_DETAIL_REQUEST = "SAVE_TENDER_DETAIL_REQUEST";
export const SAVE_TENDER_DETAIL_FAILURE = "SAVE_TENDER_DETAIL_FAILURE";

export const SAVE_BILL_SUCCESS = "SAVE_BILL_SUCCESS";
export const SAVE_BILL_REQUEST = "SAVE_BILL_REQUEST";
export const SAVE_BILL_FAILURE = "SAVE_BILL_FAILURE";

export const HNB_BANK_BIN_SUCCESS = "HNB_BANK_BIN_SUCCESS";
export const HNB_BANK_BIN_REQUEST = "HNB_BANK_BIN_REQUEST";
export const HNB_BANK_BIN_FAILURE = "HNB_BANK_BIN_FAILURE";

export const HNB_BANK_PAYMENT_SUCCESS = "HNB_BANK_PAYMENT_SUCCESS";
export const HNB_BANK_PAYMENT_REQUEST = "HNB_BANK_PAYMENT_REQUEST";
export const HNB_BANK_PAYMENT_FAILURE = "HNB_BANK_PAYMENT_FAILURE";


export const PRODUCT_SEARCH_FILTER_ALL_REQUEST = "PRODUCT_SEARCH_FILTER_ALL_REQUEST";
export const PRODUCT_SEARCH_FILTER_ALL_SUCCESS = "PRODUCT_SEARCH_FILTER_ALL_SUCCESS";
export const PRODUCT_SEARCH_FILTER_ALL_FAILURE = "PRODUCT_SEARCH_FILTER_ALL_FAILURE";

export const SEARCH_FILTER_BRAND_SUCCESS = "SEARCH_FILTER_BRAND_SUCCESS";
export const SEARCH_FILTER_BRAND_REQUEST = "SEARCH_FILTER_BRAND_REQUEST";
export const SEARCH_FILTER_BRAND_FAILURE = "SEARCH_FILTER_BRAND_FAILURE";

export const SEARCH_FILTER_COLOUR_SUCCESS = "SEARCH_FILTER_COLOUR_SUCCESS";
export const SEARCH_FILTER_COLOUR_REQUEST = "SEARCH_FILTER_COLOUR_REQUEST";
export const SEARCH_FILTER_COLOUR_FAILURE = "SEARCH_FILTER_COLOUR_FAILURE";

export const SEARCH_FILTER_GENDER_SUCCESS = "SEARCH_FILTER_GENDER_SUCCESS";
export const SEARCH_FILTER_GENDER_REQUEST = "SEARCH_FILTER_GENDER_REQUEST";
export const SEARCH_FILTER_GENDER_FAILURE = "SEARCH_FILTER_GENDER_FAILURE";

export const SEARCH_FILTER_RANGE_SUCCESS = "SEARCH_FILTER_RANGE_SUCCESS";
export const SEARCH_FILTER_RANGE_REQUEST = "SEARCH_FILTER_RANGE_REQUEST";
export const SEARCH_FILTER_RANGE_FAILURE = "SEARCH_FILTER_RANGE_FAILURE";

export const SEARCH_FILTER_RESET_SUCCESS = "SEARCH_FILTER_RESET_SUCCESS";
export const SEARCH_FILTER_SET = "SEARCH_FILTER_SET";

export const SEARCH_FILTER_COLOR = "SEARCH_FILTER_COLOR";
export const SEARCH_FILTER_PRICE = "SEARCH_FILTER_PRICE";


export const CHANGE_CURRENCY = "CHANGE_CURRENCY";

// Cart
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const INCREMENT_QTY = "INCREMENT_QTY";
export const DECREMENT_QTY = "DECREMENT_QTY";

// WishList
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";

// Compare
export const ADD_TO_COMPARE = "ADD_TO_COMPARE";
export const REMOVE_FROM_COMPARE = "REMOVE_FROM_COMPARE";

// CheckOut Process
export const CHECKOUT_REQUEST = "CHECKOUT_REQUEST";
export const CHECKOUT_SUCCESS = "CHECKOUT_SUCCESS";
export const CHECKOUT_FAILURE = "CHECKOUT_FAILURE";

// store credit

// Landing Page
export const INFOCUSEITEMS_REQUEST = "INFOCUSEITEMS_REQUEST";
export const INFOCUSEITEMS_SUCCESS = "INFOCUSEITEMS_SUCCESS";
export const INFOCUSEITEMS_FAILURE = "INFOCUSEITEMS_FAILURE";

// Theme Color
export const THEMECOLOR_DARK = 'THEMECOLOR_DARK';
export const THEMECOLOR_LIGHT = 'THEMECOLOR_LIGHT';

export const FAQ_ITEMS_REQUEST = "FAQ_ITEMS_REQUEST";
export const FAQ_ITEMS_SUCCESS = "FAQ_ITEMS_SUCCESS";
export const FAQ_ITEMS_FAILURE = "FAQ_ITEMS_FAILURE";


//product detail page
export const PRODUCT_DETAIL_REQUEST = 'PRODUCT_DETAIL_REQUEST'
export const PRODUCT_DETAIL_SUCCESS = 'PRODUCT_DETAIL_SUCCESS'
export const PRODUCT_DETAIL_FAILURE = 'PRODUCT_DETAIL_FAILURE'

export const ADD_PRODUCT_DETAIL_REQUEST = 'ADD_PRODUCT_DETAIL_REQUEST'
export const ADD_PRODUCT_DETAIL_SUCCESS = 'ADD_PRODUCT_DETAIL_SUCCESS'
export const ADD_PRODUCT_DETAIL_FAILURE = 'ADD_PRODUCT_DETAIL_FAILURE'

export const PRODUCT_ADDITIONAL_INFO_SUCCESS = 'PRODUCT_ADDITIONAL_INFO_SUCCESS'
// Collection Page
export const COLLECTIONITEMS_REQUEST = "COLLECTIONITEMS_REQUEST";
export const COLLECTIONITEMS_SUCCESS = "COLLECTIONITEMS_SUCCESS";
export const COLLECTIONITEMSMORE_SUCCESS = "COLLECTIONITEMSMORE_SUCCESS";
export const COLLECTIONITEMS_FAILURE = "COLLECTIONITEMS_FAILURE";

// User Page
export const USERINFO_REQUEST = "USERINFO_REQUEST";
export const USERINFO_SUCCESS = "USERINFO_SUCCESS";
export const USERINFO_UPDATE = "USERINFO_UPDATE";
export const USERINFO_FAILURE = "USERINFO_FAILURE";
export const USERINFO_DELETE = "USERINFO_DELETE";
export const CLEAR_USER_INFO = "CLEAR_USER_INFO";
export const WEBSESSION_UPDATE = "WEBSESSION_UPDATE";
export const CSA_USER_AUTH = "CSA_USER_AUTH";

// CSA App

export const CSA_PRODUCT_LIST_REQUEST = 'CSA_PRODUCT_LIST_REQUEST';
export const CSA_PRODUCT_LIST_SUCCESS = 'CSA_PRODUCT_LIST_SUCCESS';
export const CSA_PRODUCT_LIST_FAILURE = 'CSA_PRODUCT_LIST_FAILURE';

// price details 

export const PRICE_DETAILS_REQUEST = 'PRICE_DETAILS_REQUEST';
export const PRICE_DETAILS_SUCCESS = 'PRICE_DETAILS_SUCCESS';
export const PRICE_DETAILS_FAILURE = 'PRICE_DETAILS_FAILURE';

export const SERIALNO_REQUEST = 'SERIALNO_REQUEST';
export const SERIALNO_SUCCESS = 'SERIALNO_SUCCESS';
export const SERIALNO_FAILURE = 'SERIALNO_FAILURE';

export const RESETDBSESSION_REQUEST = 'RESETDBSESSION_REQUEST';
export const RESETDBSESSION_SUCCESS = 'RESETDBSESSION_SUCCESS';
export const RESETDBSESSION_FAILURE = 'RESETDBSESSION_FAILURE';

export const STORE_SOH_REQUEST = 'STORE_SOH_REQUEST';
export const STORE_SOH_SUCCESS = 'STORE_SOH_SUCCESS';
export const STORE_SOH_FAILURE = 'STORE_SOH_FAILURE';

export const SCHEMES_REQUEST = 'SCHEMES_REQUEST';
export const SCHEMES_SUCCESS = 'SCHEMES_SUCCESS';
export const SCHEMES_FAILURE = 'SCHEMES_FAILURE';

//APPLICABLE_SCHEMES

export const APPLICABLE_SCHEMES_REQUEST = 'APPLICABLE_SCHEMES_REQUEST';
export const APPLICABLE_SCHEMES_SUCCESS = 'APPLICABLE_SCHEMES_SUCCESS';
export const APPLICABLE_SCHEMES_FAILURE = 'APPLICABLE_SCHEMES_FAILURE';

//Generate Token

export const TOKEN_GENERATE_REQUEST = 'TOKEN_GENERATE_REQUEST';
export const TOKEN_GENERATE_SUCCESS = 'TOKEN_GENERATE_SUCCESS';
export const TOKEN_GENERATE_FAILURE = 'TOKEN_GENERATE_FAILURE';

export const GETTOKEN_REQUEST = 'GETTOKEN_REQUEST';
export const GETTOKEN_SUCCESS = 'GETTOKEN_SUCCESS';
export const GETTOKEN_FAILURE = 'GETTOKEN_FAILURE';

export const SEARCH_MEMBER_REQUEST = 'SEARCH_MEMBER_REQUEST';
export const SEARCH_MEMBER_SUCCESS = 'SEARCH_MEMBER_SUCCESS';
export const SEARCH_MEMBER_FAILURE = 'SEARCH_MEMBER_FAILURE';

export const UPDATE_EASY_PROFILE_REQUEST = 'UPDATE_EASY_PROFILE_REQUEST';
export const UPDATE_EASY_PROFILE_SUCCESS = 'UPDATE_EASY_PROFILE_SUCCESS';
export const UPDATE_EASY_PROFILE_FAILURE = 'UPDATE_EASY_PROFILE_FAILURE';

export const REGISTER_EASY_ACCOUNT_REQUEST = 'REGISTER_EASY_ACCOUNT_REQUEST';
export const REGISTER_EASY_ACCOUNT_SUCCESS = 'REGISTER_EASY_ACCOUNT_SUCCESS';
export const REGISTER_EASY_ACCOUNT_FAILURE = 'REGISTER_EASY_ACCOUNT_FAILURE';


export const SEARCH_CAPILLARY_MEMBER_REQUEST = 'SEARCH_CAPILLARY_MEMBER_REQUEST';
export const SEARCH_CAPILLARY_MEMBER_SUCCESS = 'SEARCH_CAPILLARY_MEMBER_SUCCESS';
export const SEARCH_CAPILLARY_MEMBER_FAILURE = 'SEARCH_CAPILLARY_MEMBER_FAILURE';
export const CLEAR_CAPILLARY_INFO = 'CLEAR_CAPILLARY_INFO';


export const UPDATE_CAPILLARY_PROFILE_REQUEST = 'UPDATE_CAPILLARY_PROFILE_REQUEST';
export const UPDATE_CAPILLARY_PROFILE_SUCCESS = 'UPDATE_CAPILLARY_PROFILE_SUCCESS';
export const UPDATE_CAPILLARY_PROFILE_FAILURE = 'UPDATE_CAPILLARY_PROFILE_FAILURE';

export const REGISTER_CAPILLARY_ACCOUNT_REQUEST = 'REGISTER_CAPILLARY_ACCOUNT_REQUEST';
export const REGISTER_CAPILLARY_ACCOUNT_SUCCESS = 'REGISTER_CAPILLARY_ACCOUNT_SUCCESS';
export const REGISTER_CAPILLARY_ACCOUNT_FAILURE = 'REGISTER_CAPILLARY_ACCOUNT_FAILURE';



export const CSA_PRODUCT_SEARCH_VALUES = "CSA_PRODUCT_SEARCH_VALUES";

// Tenant Page
export const TENANT_REQUEST = "TENANT_REQUEST";
export const TENANT_SUCCESS = "TENANT_SUCCESS";
export const TENANT_FAILURE = "TENANT_FAILURE";
export const TENANT_DELETE = "TENANT_DELETE";

// Store
export const STORE_REQUEST = "STORE_REQUEST";
export const STORE_SUCCESS = "STORE_SUCCESS";
export const STORE_FAILURE = "STORE_FAILURE";
export const STORE_SELECT = "STORE_SELECT";
export const STORE_OPEN = "STORE_OPEN";
export const STORE_STATE_LIST = "STORE_STATE_LIST";

//Category
export const CATEGORY_REQUEST = "CATEGORY_REQUEST";
export const CATEGORY_SUCCESS = "CATEGORY_SUCCESS";
export const CATEGORY_MORE_SUCCESS = "CATEGORY_MORE_SUCCESS";
export const CATEGORY_FAILURE = "CATEGORY_FAILURE";


//Nav
export const NAV_REQUEST = "NAV_REQUEST";
export const NAV_SUCCESS = "NAV_SUCCESS";
export const NAV_FAILURE = "NAV_FAILURE";


// Cart
export const CARTINFO_REQUEST = "CARTINFO_REQUEST";
export const CARTINFO_SUCCESS = "CARTINFO_SUCCESS";
export const CARTINFO_FAILURE = "CARTINFO_FAILURE";
export const CARTINFO_DELETE = "CARTINFO_DELETE";
export const CARTINFO_UPDATE = "CARTINFO_UPDATE";

// Address
// export const COUNTRY_REQUEST = "COUNTRY_REQUEST";
// export const COUNTRY_SUCCESS = "COUNTRY_SUCCESS";
// export const COUNTRY_FAILURE = "COUNTRY_FAILURE";

// export const STATE_REQUEST = "STATE_REQUEST";
// export const STATE_SUCCESS = "STATE_SUCCESS";
// export const STATE_FAILURE = "STATE_FAILURE";

// export const TOWN_REQUEST = "TOWN_REQUEST";
// export const TOWN_SUCCESS = "TOWN_SUCCESS";
// export const TOWN_FAILURE = "TOWN_FAILURE";

// Pincode details
export const PINCODE_REQUEST = "PINCODE_REQUEST";
export const PINCODE_SUCCESS = "PINCODE_SUCCESS";
export const PINCODE_FAILURE = "PINCODE_FAILURE";

// update user info details
export const UPDATEUSERINFO_REQUEST = "UPDATEUSERINFO_REQUEST";
export const UPDATEUSERINFO_SUCCESS = "UPDATEUSERINFO_SUCCESS";
export const UPDATEUSERINFO_FAILURE = "UPDATEUSERINFO_FAILURE";

// update user address details
export const UPDATEUSERADDR_REQUEST = "UPDATEUSERADDR_REQUEST";
export const UPDATEUSERADDR_SUCCESS = "UPDATEUSERADDR_SUCCESS";
export const UPDATEUSERADDR_FAILURE = "UPDATEUSERADDR_FAILURE";
export const CARTINFO_CLEAR = "CARTINFO_CLEAR";

//Order
export const GET_ORDER_REQUEST = "GET_ORDER_REQUEST";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const GET_ORDER_FAILURE = "GET_ORDER_FAILURE";

// store credit

export const GET_STORE_CREDIT_REQUEST = "GET_STORE_CREDIT_REQUEST";
export const GET_STORE_CREDIT_SUCCESS = "GET_STORE_CREDIT_SUCCESS";
export const GET_STORE_CREDIT_FAILURE = "GET_STORE_CREDIT_FAILURE";

export const SAVE_ORDER_REQUEST = "SAVE_ORDER_REQUEST";
export const SAVE_ORDER_SUCCESS = "SAVE_ORDER_SUCCESS";
export const SAVE_ORDER_FAILURE = "SAVE_ORDER_FAILURE";

export const SEGREGATE_CART_REQUEST = "SEGREGATE_CART_REQUEST";
export const SEGREGATE_CART_SUCCESS = "SEGREGATE_CART_SUCCESS";
export const SEGREGATE_CART_FAILURE = "SEGREGATE_CART_FAILURE";

//Order List
export const ORDERLIST_REQUEST = "ORDERLIST_REQUEST";
export const ORDERLIST_SUCCESS = "ORDERLIST_SUCCESS";
export const ORDERLIST_FAILURE = "ORDERLIST_FAILURE";
export const ORDERLIST_DELETE = "ORDERLIST_DELETE";

//order fulfillment list
export const ORDERFULFILLMENTLIST_REQUEST = "ORDERFULFILLMENTLIST_REQUEST";
export const ORDERFULFILLMENTLIST_SUCCESS = "ORDERFULFILLMENTLIST_SUCCESS";
export const ORDERFULFILLMENTLIST_FAILURE = "ORDERFULFILLMENTLIST_FAILURE";

//order acknowledge

export const ORDERACKNOWLEDGELIST_REQUEST = "ORDERACKNOWLEDGELIST_REQUEST";
export const ORDERACKNOWLEDGELIST_SUCCESS = "ORDERACKNOWLEDGELIST_SUCCESS";
export const ORDERACKNOWLEDGELIST_FAILURE = "ORDERACKNOWLEDGELIST_FAILURE";

//order pickslip



export const ORDERPICKSLIPLIST_REQUEST = "ORDERPICKSLIPLIST_REQUEST";
export const ORDERPICKSLIPLIST_SUCCESS = "ORDERPICKSLIPLIST_SUCCESS";
export const ORDERPICKSLIPLIST_FAILURE = "ORDERPICKSLIPLIST_FAILURE";

//PRODUCT DETAILS

export const PRODUCTDETAILS_REQUEST = "PRODUCTDETAILS_REQUEST";
export const PRODUCTDETAILS_SUCCESS = "PRODUCTDETAILS_SUCCESS";
export const PRODUCTDETAILS_FAILURE = "PRODUCTDETAILS_FAILURE";


//SAVE PACK 
export const SAVEPACK_REQUEST = "SAVEPACK_REQUEST";
export const SAVEPACK_SUCCESS = "SAVEPACK_SUCCESS";
export const SAVEPACK_FAILURE = "SAVEPACK_FAILURE";

//SAVE ORDERACKNOWLEDGE


export const SUBMITORDERACKNOWLEDGE_REQUEST = "SUBMITORDERACKNOWLEDGE_REQUEST";
export const SUBMITORDERACKNOWLEDGE_SUCCESS = "SUBMITORDERACKNOWLEDGE_SUCCESS";
export const SUBMITORDERACKNOWLEDGE_FAILURE = "SUBMITORDERACKNOWLEDGE_FAILURE";


//Return Order List
export const RETURN_ORDERLIST_REQUEST = "RETURN_ORDERLIST_REQUEST";
export const RETURN_ORDERLIST_SUCCESS = "RETURN_ORDERLIST_SUCCESS";
export const RETURN_ORDERLIST_FAILURE = "RETURN_ORDERLIST_FAILURE";

// Cancel Order

export const CANCEL_ORDER_REQUEST = 'CANCEL_ORDER_REQUEST';
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_FAILURE = 'CANCEL_ORDER_FAILURE';
export const CANCEL_ORDER_DELETE = 'CANCEL_ORDER_DELETE';

export const SAVE_CANCEL_ORDER_REQUEST = 'SAVE_CANCEL_ORDER_REQUEST';
export const SAVE_CANCEL_ORDER_SUCCESS = 'SAVE_CANCEL_ORDER_SUCCESS';
export const SAVE_CANCEL_ORDER_FAILURE = 'SAVE_CANCEL_ORDER_FAILURE';
export const SAVE_CANCEL_ORDER_DELETE = 'SAVE_CANCEL_ORDER_DELETE';

export const CANCEL_ORDER_REASON_LIST_REQUEST = 'CANCEL_ORDER_REASON_LIST_REQUEST';
export const CANCEL_ORDER_REASON_LIST_SUCCESS = 'CANCEL_ORDER_REASON_LIST_SUCCESS';
export const CANCEL_ORDER_REASON_LIST_FAILURE = 'CANCEL_ORDER_REASON_LIST_FAILURE';

export const RETURN_ORDER_FILTERLIST = 'RETURN_ORDER_FILTERLIST';
export const RETURN_ORDER_PRODUCT = 'RETURN_ORDER_PRODUCT';

export const RETURN_ORDER_REASONREQUEST = "RETURN_ORDER_REASONREQUEST";
export const RETURN_ORDER_REASONSUCCESS = "RETURN_ORDER_REASONSUCCESS";
export const RETURN_ORDER_REASONFAILURE = "RETURN_ORDER_REASONFAILURE";

export const SAVE_RETURN_ORDER_REQUEST = "SAVE_RETURN_ORDER_REQUEST";
export const SAVE_RETURN_ORDER_SUCCESS = "SAVE_RETURN_ORDER_SUCCESS";
export const SAVE_RETURN_ORDER_FAILURE = "SAVE_RETURN_ORDER_FAILURE";
export const RETURNORDERINFO_CLEAR = "RETURNORDERINFO_CLEAR";

//Wishlist
export const WISHLIST_REQUEST = "WISHLIST_REQUEST";
export const WISHLIST_SUCCESS = "WISHLIST_SUCCESS";
export const WISHLIST_FAILURE = "WISHLIST_FAILURE";
export const WISHLIST_DELETE = "WISHLIST_DELETE";
export const WISHLIST_UPDATE = "WISHLIST_UPDATE";
export const WISHLIST_CLEAR = "WISHLIST_CLEAR";

//submit review
export const SUBMITREVIEW_REQUEST = "SUBMITREVIEW_REQUEST";
export const SUBMITREVIEW_SUCCESS = "SUBMITREVIEW_SUCCESS";
export const SUBMITREVIEW_FAILURE = "SUBMITREVIEW_FAILURE";

//change password
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

//reset password
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

//CONTACT api

export const CONTACT_REQUEST = "CONTACT_REQUEST";
export const CONTACT_SUCCESS = "CONTACT_SUCCESS";
export const CONTACT_FAILURE = "CONTACT_FAILURE";   

//ENQUIRY api

export const ENQUIRY_REQUEST = "ENQUIRY_REQUEST";
export const ENQUIRY_SUCCESS = "ENQUIRY_SUCCESS";
export const ENQUIRY_FAILURE = "ENQUIRY_FAILURE";   

//Compare API

export const PRODUCT_COMPARE_REQUEST = "PRODUCT_COMPARE_REQUEST";
export const PRODUCT_COMPARE_SUCCESS = "PRODUCT_COMPARE_SUCCESS";
export const PRODUCT_COMPARE_FAILURE = "PRODUCT_COMPARE_FAILURE";   

export const ABOUT_US_SUCCESS = 'ABOUT_US_SUCCESS'
export const ABOUT_US_FAILURE = 'ABOUT_US_FAILURE'
export const ABOUT_US_REQUEST = 'ABOUT_US_REQUEST'

export const CART_PROFILE_UPDATE = 'CART_PROFILE_UPDATE'
